// API actions
export const API_ERROR = 'API_ERROR';
export const API_DATA_REQUESTED = 'API_DATA_REQUESTED';
export const API_REQUEST_OK = 'API_REQUEST_OK';

// Map Actions
export const GRID_DATA_RECEIVED = 'GRID_DATA_RECEIVED';
export const OBSTACLES_DATA_RECEIVED = 'OBSTACLES_DATA_RECEIVED';
export const GEOFENCE_DATA_RECEIVED = 'GEOFENCE_DATA_RECEIVED';

// Inspector actions
export const UPDATE_INSPECTOR = 'UPDATE_INSPECTOR';
export const CLOSE_INSPECTOR = 'CLOSE_INSPECTOR';
export const SELECT_MISSION = 'SELECT_MISSION';

//Order Track Websocket action
export const LIVE_DATA = 'LIVE_DATA';
export const MAP_MISSION_ID = 'MAP_MISSION_ID';
export const AIRSPACE_TRIGGER = 'AIRSPACE_TRIGGER';

// Auth Actions
export const AUTH_REQUESTED = 'AUTH_REQUESTED';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_ERROR = 'AUTH_ERROR';

// Order actions
export const ORDERS_RECEIVED = 'ORDERS_RECEIVED';
export const ORDER_RECEIVED = 'ORDER_RECEIVED';
export const LANDING_ZONES_RECEIVED = 'LANDING_ZONES_RECEIVED';
export const CREATED_ORDERS_RECEIVED = 'CREATED_ORDERS_RECEIVED';
export const ORDER_CREATED = 'ORDER_CREATED';
export const EXTRA_ORDER_CREATED_SUCCESS = 'EXTRA_ORDER_CREATED_SUCCESS';
export const ORDER_STATUS_UPDATED = 'ORDER_STATUS_UPDATED_FULFILLED';
export const MISSION_RECEIVED = 'MISSION_RECEIVED';
export const MISSIONS_RECEIVED = 'MISSIONS_RECEIVED';
export const ORDER_TRACKING_RECEIVED = 'ORDER_TRACKING_RECEIVED';
export const ORDERS_MERGED = 'ORDERS_MERGED';
export const MERGED_ORDERS_RECEIVED = 'MERGED_ORDERS_RECEIVED';
export const ORDER_ACCEPTED_REQUEST = 'ORDER_ACCEPTED_REQUEST';
export const ORDER_ACCEPTED_SUCCESS = 'ORDER_ACCEPTED_SUCCESS';
export const ORDER_ACCEPTED_FAILURE = 'ORDER_ACCEPTED_FAILURE';
export const ORDER_REJECTED_REQUEST = 'ORDER_REJECTED_REQUEST';
export const ORDER_REJECTED_SUCCESS = 'ORDER_REJECTED_SUCCESS';
export const ORDER_REJECTED_FAILURE = 'ORDER_REJECTED_FAILURE';
export const ORDER_REFUNDED_REQUEST = 'ORDER_REFUNDED_REQUEST';
export const ORDER_REFUNDED_SUCCESS = 'ORDER_REFUNDED_SUCCESS';
export const ORDER_REFUNDED_FAILURE = 'ORDER_REFUNDED_FAILURE';
export const GET_ORDER_HISTORY_REQUEST = 'GET_ORDER_HISTORY_REQUEST';
export const GET_ORDER_HISTORY_SUCCESS = 'GET_ORDER_HISTORY_SUCCESS';
export const GET_ORDER_HISTORY_FAILURE = 'GET_ORDER_HISTORY_FAILURE';
export const GET_LATEST_EXPECTED_ORDER_TIME_REQUEST =
  'GET_LATEST_EXPECTED_ORDER_TIME_REQUEST';
export const GET_LATEST_EXPECTED_ORDER_TIME_SUCCESS =
  'GET_LATEST_EXPECTED_ORDER_TIME_SUCCESS';
export const GET_LATEST_EXPECTED_ORDER_TIME_FAILURE =
  'GET_LATEST_EXPECTED_ORDER_TIME_FAILURE';
export const JE_ORDER_ACCEPTED_REQUEST = 'JE_ORDER_ACCEPTED_REQUEST';
export const JE_ORDER_ACCEPTED_SUCCESS = 'JE_ORDER_ACCEPTED_SUCCESS';
export const JE_ORDER_ACCEPTED_FAILURE = 'JE_ORDER_ACCEPTED_FAILURE';
export const CLEAR_SELECTED_ORDER = 'CLEAR_SELECTED_ORDER';
export const ENABLE_ROUTE_REQUEST = 'ENABLE_ROUTE_REQUEST';
export const ENABLE_ROUTE_SUCCESS = 'ENABLE_ROUTE_SUCCESS';
export const ENABLE_ROUTE_FAILURE = 'ENABLE_ROUTE_FAILURE';
export const ORDERS_LOADING = 'ORDERS_LOADING';
export const ADD_NOTE = 'ADD_NOTE';
export const ADD_NOTE_SUCCESS = 'ADD_NOTE_SUCCESS';
export const ADD_NOTE_FAILURE = 'ADD_NOTE_FAILURE';
export const SET_SELECTED_ORDER = 'SET_SELECTED_ORDER';
export const SET_ORDER_STATUS_FILTER = 'SET_ORDER_STATUS_FILTER';
export const SET_ORDER_WITHIN_TIME_FILTER = 'SET_ORDER_WITHIN_TIME_FILTER';
export const GET_STORES_ORDER_CAPACITY = 'GET_STORES_ORDER_CAPACITY';
export const ALL_ORDERS_FOR_TODAY_TOMORROW_REQUEST =
  'ALL_ORDERS_FOR_TODAY_TOMORROW_REQUEST';
export const ALL_ORDERS_FOR_TODAY_TOMORROW_SUCCESS =
  'ALL_ORDERS_FOR_TODAY_TOMORROW_SUCCESS';
export const ALL_ORDERS_FOR_TODAY_TOMORROW_FAILURE =
  'ALL_ORDERS_FOR_TODAY_TOMORROW_FAILURE';
export const UPDATE_DELIVERY_SLOT_REQUEST = 'UPDATE_DELIVERY_SLOT_REQUEST';
export const UPDATE_DELIVERY_SLOT_SUCCESS = 'UPDATE_DELIVERY_SLOT_SUCCESS';
export const UPDATE_DELIVERY_SLOT_FAILURE = 'UPDATE_DELIVERY_SLOT_FAILURE';
export const RESEND_ORDER_REQUEST = 'RESEND_ORDER_REQUEST';
export const RESEND_ORDER_SUCCESS = 'RESEND_ORDER_SUCCESS';
export const RESEND_ORDER_FAILURE = 'RESEND_ORDER_FAILURE';

// Admin actions
export const GET_ADMIN_SETTINGS_REQUEST = 'GET_ADMIN_SETTINGS_REQUEST';
export const GET_ADMIN_SETTINGS_SUCCESS = 'GET_ADMIN_SETTINGS_SUCCESS';
export const GET_ADMIN_SETTINGS_FAILURE = 'GET_ADMIN_SETTINGS_FAILURE';
export const SET_AUTO_ACCEPT_REQUEST = 'SET_AUTO_ACCEPT_REQUEST';
export const SET_AUTO_ACCEPT_SUCCESS = 'SET_AUTO_ACCEPT_SUCCESS';
export const SET_AUTO_ACCEPT_FAILURE = 'SET_AUTO_ACCEPT_FAILURE';
export const SET_OPEN_STORE_REQUEST = 'SET_OPEN_STORE_REQUEST';
export const SET_OPEN_STORE_SUCCESS = 'SET_OPEN_STORE_SUCCESS';
export const SET_OPEN_STORE_FAILURE = 'SET_OPEN_STORE_FAILURE';
export const SET_CELL_BANNER_REQUEST = 'SET_CELL_BANNER_REQUEST';
export const SET_CELL_BANNER_SUCCESS = 'SET_CELL_BANNER_REQUEST';
export const SET_CELL_BANNER_FAILURE = 'SET_CELL_BANNER_FAILURE';
export const GET_CELLS_REQUEST = 'GET_CELLS_REQUEST';
export const GET_CELLS_SUCCESS = 'GET_CELLS_SUCCESS';
export const GET_CELLS_FAILURE = 'GET_CELLS_FAILURE';
export const GET_CELL_COMMERCIAL_CONFIG_REQUESTED = 'GET_CELL_COMMERCIAL_CONFIG_REQUESTED';
export const GET_CELL_COMMERCIAL_CONFIG_SUCCESSFUL = 'GET_CELL_COMMERCIAL_CONFIG_SUCCESSFUL';
export const GET_CELL_COMMERCIAL_CONFIG_FAILED = 'GET_CELL_COMMERCIAL_CONFIG_FAILED';
export const SET_SELECTED_CELL = 'SET_SELECTED_CELL';
export const SEND_NOTIFICATION_REQUEST = 'SEND_NOTIFICATION_REQUEST';
export const SEND_NOTIFICATION_SUCCESS = 'SEND_NOTIFICATION_SUCCESS';
export const SEND_NOTIFICATION_FAILURE = 'SEND_NOTIFICATION_FAILURE';

// Address actions
export const ADDRESSES_RECEIVED = 'ADDRESSES_RECEIVED';
export const SET_ADDRESS = 'SET_ADDRESS';

// Geofence actions
export const SET_GEOFENCE_ID = 'SET_GEOFENCE_ID';
export const SET_GEOFENCE_NAME = 'SET_GEOFENCE_NAME';
export const SET_GEOFENCE_GEOJSON = 'SET_GEOFENCE_GEOJSON';
export const GEOFENCES_RECEIVED = 'GEOFENCES_RECEIVED';
export const GEOFENCE_SAVED = 'GEOFENCE_SAVED';
export const GEOFENCE_DELETED = 'GEOFENCE_DELETED';
export const CLEAR_GEOFENCE_STATE = 'CLEAR_GEOFENCE_STATE';

// Obstacle actions
export const SET_OBSTACLE_ID = 'SET_OBSTACLE_ID';
export const SET_OBSTACLE_NAME = 'SET_OBSTACLE_NAME';
export const SET_OBSTACLE_GEOJSON = 'SET_OBSTACLE_GEOJSON';
export const SET_OBSTACLE_GEOHASH = 'SET_OBSTACLE_GEOHASH';
export const SET_OBSTACLE_GROUNDRISK = 'SET_OBSTACLE_GROUNDRISK';
export const SET_OBSTACLE_CATEGORY = 'SET_OBSTACLE_CATEGORY';
export const SET_OBSTACLE_CELL_ID = 'SET_OBSTACLE_CELL_ID';
export const OBSTACLES_RECEIVED = 'OBSTACLES_RECEIVED';
export const OBSTACLE_SAVED = 'OBSTACLE_SAVED';
export const OBSTACLE_REMOVED = 'OBSTACLE_REMOVED';
export const CLEAR_OBSTACLE_STATE = 'CLEAR_OBSTACLE_STATE';

// Elevation Hazards actions
export const ELEVATION_HAZARDS_RECEIVED = 'ELEVATION_HAZARDS_RECEIVED';
export const CLEAR_ELEVATION_HAZARDS = 'CLEAR_ELEVATION_HAZARDS';

// UI & high level actions
export const QUEUE_NOTIFICATION = 'QUEUE_NOTIFICATION';
export const CLOSE_NOTIFICATION = 'CLOSE_NOTIFICATION';
export const CLEAR_NOTIFICATIONS = 'CLEAR_NOTIFICATIONS';
export const SET_ALERT = 'SET_ALERT';
export const CLEAR_ALERT = 'CLEAR_ALERT';
export const LOADING = 'LOADING';
export const LOADING_DONE = 'LOADING_DONE';
export const UPDATE_CUSTOM_VIEWS = 'UPDATE_CUSTOM_VIEWS';
export const SET_NAVBAR = 'SET_NAVBAR';
export const HIDE_TOPBAR = 'HIDE_TOPBAR';

// Tools actions
export const ADD_GEOHASH_GROUP = 'ADD_GEOHASH_GROUP';
export const REMOVE_GEOHASH_GROUP = 'REMOVE_GEOHASH_GROUP';
export const MISSION_CREATED = 'MISSION_CREATED';
export const ADD_TUPLE_LIST = 'ADD_TUPLE_LIST';

// UAV actions
export const SET_CONNECTION_SETTINGS = 'SET_CONNECTION_SETTINGS';
export const USE_CUBIC = 'USE_CUBIC';
export const USE_VIDEO = 'USE_VIDEO';
export const TEST_VIDEO_CONNECTING = 'TEST_VIDEO_CONNECTING';
export const TEST_VIDEO = 'TEST_VIDEO';
export const FOLLOW_DRONE = 'FOLLOW_DRONE';
export const SET_VIDEO_URL = 'SET_VIDEO_URL';
export const SET_SERVER_ADDRESS = 'SET_SERVER_ADDRESS';
export const SET_AIRCRAFT = 'SET_AIRCRAFT';
export const SET_FAILOVER_SOCKETS = 'SET_FAILOVER_SOCKETS';
export const SET_PILOT_ROLE = 'SET_PILOT_ROLE';
export const SET_PIN = 'SET_PIN';
export const SET_LATENCY = 'SET_LATENCY';
export const SET_SOCKET_STATUS = 'SET_SOCKET_STATUS';
export const SET_VOLTAGE = 'SET_VOLTAGE';
export const SET_UAV_CONNECTING = 'SET_UAV_CONNECTING';
export const SET_UAV_CONNECTED = 'SET_UAV_CONNECTED';
export const UAV_DNS_RECEIVED = 'UAV_DNS_RECEIVED';
export const UAV_MESSAGE_RECEIVED = 'UAV_MESSAGE_RECEIVED';
export const SET_UAV_ERROR = 'SET_UAV_ERROR';
export const SET_MISSION_DETAILS = 'SET_MISSION_DETAILS';
export const DISCONNECT_UAV = 'DISCONNECT_UAV';
export const SET_MISSION_POINTS = 'SET_MISSION_POINTS';
export const SET_GEOFENCE = 'SET_GEOFENCE';
export const CLEAR_MISSION_POINTS = 'CLEAR_MISSION_POINTS';
export const SET_UAV_DNS_LIST = 'SET_UAV_DNS_LIST';
export const SET_USER_PERMISSIONS = 'SET_USER_PERMISSIONS';
export const CALL_COMMAND = 'CALL_COMMAND';
export const SHOW_MAP = 'SHOW_MAP';
export const SHOW_FLIGHT_LOGGER = 'SHOW_FLIGHT_LOGGER';
export const FETCH_PREVIOUS_FLIGHTS_REQUEST = 'FETCH_PREVIOUS_FLIGHTS_REQUEST';
export const FETCH_PREVIOUS_FLIGHTS_SUCCESS = 'FETCH_PREVIOUS_FLIGHTS_SUCCESS';
export const FETCH_PREVIOUS_FLIGHTS_FAILURE = 'FETCH_PREVIOUS_FLIGHTS_FAILURE';
export const SET_SELECTED_PREVIOUS_FLIGHT = 'SET_SELECTED_PREVIOUS_FLIGHT';
export const UPDATE_PREVIOUS_FLIGHT_REPORT = 'UPDATE_PREVIOUS_FLIGHT_REPORT';
export const SET_PARSED_LOGS = 'SET_PARSED_LOGS';
export const SET_MISSION_PAUSED = 'SET_MISSION_PAUSED';
export const SET_PILOT_INFO = 'SET_PILOT_INFO';
export const SET_TELEM_STATUS = 'SET_TELEM_STATUS';
export const RESET_COMMANDS = 'RESET_COMMANDS';
export const SET_MISSION_ELEVATION = 'SET_MISSION_ELEVATION_GRAPH_LINES';
export const SET_DRONE_ALTITUDE_GRAPH_LINE = 'SET_DRONE_ALTITUDE_GRAPH_LINE';
export const SET_PERFORMANCE_GRAPH_LINES = 'SET_PERFORMANCE_GRAPH_LINES';
export const RESET_PERFORMANCE_GRAPH = 'RESET_PERFORMANCE_GRAPH';
export const SET_SHOW_PERFORMANCE = 'SET_SHOW_PERFORMANCE';
export const SET_REPLAY_MISSION = 'SET_REPLAY_MISSION';

// Route Planner
export const SET_ROUTE_EIRCODE = 'SET_ROUTE_EIRCODE';
export const SET_ROUTE_NAME = 'SET_ROUTE_NAME';
export const SET_ROUTE_TYPE = 'SET_ROUTE_TYPE';
export const SET_ROUTE_REL_ALT = 'SET_ROUTE_REL_ALT';
export const SET_DISABLE_SLOPED_ASCENT = 'SET_SLOPED_ASCENT';
export const SET_UPDATE_ROUTE_REL_ALT = 'SET_UPDATE_ROUTE_REL_ALT';
export const SET_ROUTE_HIGHWAY = 'SET_ROUTE_HIGHWAY';
export const CREATING_ROUTE_REQUEST = 'CREATING_ROUTE_REQUEST';
export const CREATING_ROUTE_SUCCESS = 'CREATING_ROUTE_SUCCESS';
export const CREATING_ROUTE_FAILURE = 'CREATING_ROUTE_FAILURE';
export const UPDATING_ROUTE_REQUEST = 'UPDATING_ROUTE_REQUEST';
export const UPDATING_ROUTE_SUCCESS = 'UPDATING_ROUTE_SUCCESS';
export const UPDATING_ROUTE_FAILURE = 'UPDATING_ROUTE_FAILURE';
export const DELETE_ROUTE_REQUEST = 'DELETE_ROUTE_REQUEST';
export const DELETE_ROUTE_SUCCESS = 'DELETE_ROUTE_SUCCESS';
export const DELETE_ROUTE_FAILURE = 'DELETE_ROUTE_FAILURE';
export const FETCH_ROUTES_REQUEST = 'FETCH_ROUTES_REQUEST';
export const FETCH_ROUTES_SUCCESS = 'FETCH_ROUTES_SUCCESS';
export const FETCH_ROUTES_FAILURE = 'FETCH_ROUTES_FAILURE';
export const TOGGLE_NEW_LINE_AND_POINTS = 'TOGGLE_NEW_LINE_AND_POINTS';
export const TOGGLE_UPDATE_LINE_AND_POINTS = 'TOGGLE_UPDATE_LINE_AND_POINTS';
export const SET_NEW_GEOJSON = 'SET_NEW_GEOJSON';
export const SET_UPDATE_GEOJSON = 'SET_UPDATE_GEOJSON';
export const SET_NEW_ROUTE = 'SET_NEW_ROUTE';
export const CLEAR_NEW_ROUTE = 'CLEAR_NEW_ROUTE';
export const SET_UPDATE_ROUTE = 'SET_UPDATE_ROUTE';
export const CLEAR_UPDATE_ROUTE = 'CLEAR_UPDATE_ROUTE';
export const SHOW_DELETE_CONFIRM = 'SHOW_DELETE_CONFIRM';
export const CLOSE_DELETE_CONFIRM = 'CLOSE_DELETE_CONFIRM';
export const SET_TAB = 'SET_TAB';
export const SET_EIRCODE = 'SET_EIRCODE';
export const SET_DRONE_ELEVATION_PATH = 'SET_DRONE_ELEVATION_PATH';
export const SET_DRONE_ALTITUDE_PATH = 'SET_DRONE_ALTITUDE_PATH';
// Elevation points on the map for new route
export const SET_NEW_ROUTE_ELEVATION_POINTS = 'SET_NEW_ROUTE_ELEVATION_POINTS';
// Elevation of starting point of new route
export const SET_NEW_ROUTE_START_POINT_ELEVATION =
  'SET_NEW_ROUTE_START_POINT_ELEVATION';
// Start point of new route
export const SET_NEW_ROUTE_START_POINT = 'SET_NEW_ROUTE_START_POINT';
// Elevation points on the map for update route (existing route selected from route list)
export const SET_UPDATE_ROUTE_ELEVATION_POINTS =
  'SET_UPDATE_ROUTE_ELEVATION_POINTS';
// Elevation of the start point for the update route (existing route selected from route list)
export const SET_UPDATE_ROUTE_START_POINT_ELEVATION =
  'SET_UPDATE_ROUTE_START_POINT_ELEVATION';
// Start point of update route
export const SET_UPDATE_ROUTE_START_POINT = 'SET_UPDATE_ROUTE_START_POINT';
export const FETCH_ROUTE_QR_CODE = 'FETCH_ROUTE_QR_CODE';
export const FETCH_ROUTE_QR_CODE_SUCCESS = 'SET_ROUTE_QR_CODE';
export const GET_ALL_ADDRESS_LOCATIONS = 'GET_ALL_ADDRESS_LOCATIONS';
export const FETCH_ROUTE_QR_CODE_FAILURE = 'FETCH_ROUTE_QR_CODE_FAILURE';
export const SET_DROP_LOCATION = 'SET_DROP_LOCATION';
export const ADD_SELECTED_HEXES = 'ADD_SELECTED_HEXES';
export const CLEAR_OBSTACLES_SELECTED = 'CLEAR_OBSTACLES_SELECTED';
export const SAVE_NEW_OBSTACLES = 'SAVE_NEW_OBSTACLES';
export const SET_OBSTACLE_TYPE = 'SET_OBSTACLE_TYPE';
export const SET_EXISTING_OBSTACLES = 'SET_EXISTING_OBSTACLES_FULFILLED';
export const CLEAR_ALL_OBSTACLES_AND_REGION = 'CLEAR_ALL_OBSTACLES_AND_REGION';
export const SET_OBSTACLES_REGION = 'SET_OBSTACLES_REGION';
export const LOADING_OBSTACLES_REGION = 'LOADING_OBSTACLES_REGION';
export const SET_SAVING_OBSTACLES = 'SET_SAVING_OBSTACLES';
export const SET_HAS_DELETED_OBSTACLE = 'SET_HAS_DELETED_OBSTACLE';

// BOM actions
export const AIRCRAFT_LIST_RECEIVED = 'AIRCRAFT_LIST_RECEIVED';
export const ASSET_LIST_RECEIVED = 'ASSET_LIST_RECEIVED';
export const ASSET_VERSIONS_RECEIVED = 'ASSET_VERSIONS_RECEIVED';
export const ASSET_PARTS_LIST_RECEIVED = 'ASSET_PARTS_LIST_RECEIVED';
export const AIRCRAFT_PARTS_RECEIVED = 'AIRCRAFT_PARTS_RECEIVED';
export const ASSET_VERSION_DELTA_APPLIED = 'ASSET_VERSION_DELTA_APPLIED';
export const ASSET_VERSION_DELTA_RECEIVED = 'ASSET_VERSION_DELTA_RECEIVED';
export const INACTIVE_ASSET_PARTS_LIST_RECEIVED =
  'INACTIVE_ASSET_PARTS_LIST_RECEIVED';
export const ASSET_VERSION_ASSEMBLIES_RECEIVED =
  'ASSET_VERSION_ASSEMBLIES_RECEIVED';
export const ASSET_VERSION_RECEIVED = 'ASSET_VERSION_RECEIVED';
export const ASSET_PART_REPLACED = 'ASSET_PART_REPLACED';
export const ASSET_VERSION_CREATED = 'ASSET_VERSION_CREATED';
export const ASSET_PART_DEACTIVATED = 'ASSET_PART_DEACTIVATED';
export const AIRCRAFT_ID_PARTS_RECEIVED = 'AIRCRAFT_ID_PARTS_RECEIVED';
export const AIRCRAFT_TYPE_LIST = 'AIRCRAFT_TYPE_LIST';
export const ASSET_CREATED = 'ASSET_CREATED';
export const ASSEMBLIES_LIST_RECEIVED = 'ASSEMBLIES_LIST_RECEIVED';
export const AIRCRAFT_CREATED_RECEIVED = 'AIRCRAFT_CREATED_RECEIVED';
export const PART_CREATED = 'PART_CREATED';
export const TYPE_CREATED = 'TYPE_CREATED';
export const PART_UPDATED = 'PART_UPDATED';
export const ADD_PART_TO_AIRCRAFT = 'ADD_PART_TO_AIRCRAFT';

// Live aircraft actions
export const GET_AIRCRAFT_REQUEST = 'GET_AIRCRAFT_REQUEST';
export const GET_AIRCRAFT_SUCCESS = 'GET_AIRCRAFT_SUCCESS';
export const GET_AIRCRAFT_FAILURE = 'GET_AIRCRAFT_FAILURE';
export const SUBSCRIBE_TO_TELEMETRY_PENDING = 'SUBSCRIBE_TO_TELEMETRY_PENDING';
export const SOCKET_OPEN = 'SOCKET_OPEN';
export const SOCKET_MESSAGE = 'SOCKET_MESSAGE';
export const SOCKET_RECONNECT = 'SOCKET_RECONNECT';
export const SOCKET_CLOSED = 'SOCKET_CLOSED';
export const SOCKET_ERROR = 'SOCKET_ERROR';
export const SUBSCRIBE_TO_TELEMETRY_FAILED = 'SUBSCRIBE_TO_TELEMETRY_FAILED';
export const TELEMETRY_SUBSCRIBED = 'TELEMETRY_SUBSCRIBED';
export const UPDATE_LIVE_AIRCRAFT_DATA = 'UPDATE_LIVE_AIRCRAFT_DATA';
export const UPDATE_PILOT_DATA = 'UPDATE_PILOT_DATA';
export const MISSION_STOPPED = 'MISSION_STOPPED';
export const MISSION_STARTED = 'MISSION_STARTED';
export const CLEAR_TELEMETRY_DATA = 'CLEAR_TELEMETRY_DATA';
export const ADD_MISSION_TO_AIRCRAFT_PENDING =
  'ADD_MISSION_TO_AIRCRAFT_PENDING';
export const ADD_MISSION_TO_AIRCRAFT_FULFILLED =
  'ADD_MISSION_TO_AIRCRAFT_FULFILLED';
export const ADD_MISSION_TO_AIRCRAFT_FAILED = 'ADD_MISSION_TO_AIRCRAFT_FAILED';
export const TRIGGER_UAV_EVENT = 'TRIGGER_UAV_EVENT';
export const END_UAV_EVENT = 'END_UAV_EVENT';
export const CLEAR_AIRCRAFT = 'CLEAR_AIRCRAFT';
export const TOGGLE_GEOTUNNEL = 'TOGGLE_GEOTUNNEL';
export const TOGGLE_SHOW_SITL = 'TOGGLE_SHOW_SITL';
export const CHOOSE_LOCATION = 'CHOOSE_LOCATION';
export const CHOOSE_AIRCRAFT = 'CHOOSE_AIRCRAFT';

export const MESSAGING_PENDING = 'MESSAGING_PENDING';
export const MESSAGING_FAILED = 'MESSAGING_FAILED';
export const GROUND_TEAM_DATA = 'GROUND_TEAM_DATA';
export const UPDATE_CLIENTS = 'UPDATE_CLIENTS';

export const GET_LANDING_PADS_SUCCESS = 'GET_LANDING_PADS_SUCCESS';
export const GET_LANDING_PADS_FAILURE = 'GET_LANDING_PADS_FAILURE';

export const UPDATE_LANDING_PAD_PENDING = 'UPDATE_LANDING_PAD_PENDING';
export const UPDATE_LANDING_PAD_SUCCESS = 'UPDATE_LANDING_PAD_SUCCESS';
export const UPDATE_LANDING_PAD_FAILURE = 'UPDATE_LANDING_PAD_FAILURE';

export const LINK_PAD_WITH_AIRCRAFT_PENDING = 'LINK_PAD_WITH_AIRCRAFT_PENDING';
export const LINK_PAD_WITH_AIRCRAFT_SUCCESS = 'LINK_PAD_WITH_AIRCRAFT_SUCCESS';
export const LINK_PAD_WITH_AIRCRAFT_FAILURE = 'LINK_PAD_WITH_AIRCRAFT_FAILURE';
export const REMOVE_AIRCRAFT_FROM_PAD_PENDING =
  'REMOVE_AIRCRAFT_FROM_PAD_PENDING';
export const REMOVE_AIRCRAFT_FROM_PAD_SUCCESS =
  'REMOVE_AIRCRAFT_FROM_PAD_SUCCESS';
export const REMOVE_AIRCRAFT_FROM_PAD_FAILURE =
  'REMOVE_AIRCRAFT_FROM_PAD_FAILURE';

export const LINK_PAD_WITH_CHANNEL = 'LINK_PAD_WITH_CHANNEL';

// Admin actions (orderhub)
export const GET_PARTNERS_REQUEST = 'GET_PARTNERS_REQUEST';
export const GET_PARTNERS_SUCCESS = 'GET_PARTNERS_SUCCESS';
export const GET_PARTNERS_FAILURE = 'GET_PARTNERS_FAILURE';
export const GET_REGIONS_REQUEST = 'GET_REGIONS_REQUEST';
export const GET_REGIONS_SUCCESS = 'GET_REGIONS_SUCCESS';
export const GET_REGIONS_FAILURE = 'GET_REGIONS_FAILURE';
export const GET_POINTOFSALE_REQUEST = 'GET_POINTOFSALE_REQUEST';
export const GET_POINTOFSALE_SUCCESS = 'GET_POINTOFSALE_SUCCESS';
export const GET_POINTOFSALE_FAILURE = 'GET_POINTOFSALE_FAILURE';
export const UPDATE_POINTOFSALE_REQUEST = 'UPDATE_POINTOFSALE_REQUEST';
export const UPDATE_POINTOFSALE_SUCCESS = 'UPDATE_POINTOFSALE_SUCCESS';
export const UPDATE_POINTOFSALE_FAILURE = 'UPDATE_POINTOFSALE_FAILURE';
export const ADD_POINTOFSALE_REQUEST = 'ADD_POINTOFSALE_REQUEST';
export const ADD_PARTNER_REQUEST = 'ADD_PARTNER_REQUEST';
export const UPLOAD_IMAGE_REQUEST = 'UPLOAD_IMAGE_REQUEST';
export const ADD_POINTOFSALE_SUCCESS = 'ADD_POINTOFSALE_SUCCESS';
export const ADD_POINTOFSALE_FAILURE = 'ADD_POINTOFSALE_FAILURE';
export const UPDATE_OPENING_HOURS_REQUEST = 'UPDATE_OPENING_HOURS_REQUEST';
export const UPDATE_OPENING_HOURS_SUCCESS = 'UPDATE_OPENING_HOURS_SUCCESS';
export const UPDATE_OPENING_HOURS_FAILURE = 'UPDATE_OPENING_HOURS_FAILURE';
export const SET_SELECTED_REGION = 'SET_SELECTED_REGION';
export const SET_REFRESH_INTERVAL = 'SET_REFRESH_INTERVAL';

// Dev actions
export const FORCE_ORDER_STATUS_FETCHING = 'FORCE_ORDER_STATUS_FETCHING';
export const FORCE_ORDER_STATUS_SUCCESS = 'FORCE_ORDER_STATUS_SUCCESS';
export const FORCE_ORDER_STATUS_FAILURE = 'FORCE_ORDER_STATUS_FAILURE';
export const FORCE_ORDER_EIRCODE_FETCHING = 'FORCE_ORDER_EIRCODE_FETCHING';
export const FORCE_ORDER_EIRCODE_SUCCESS = 'FORCE_ORDER_EIRCODE_SUCCESS';
export const FORCE_ORDER_EIRCODE_FAILURE = 'FORCE_ORDER_EIRCODE_FAILURE';
export const FORCE_ORDER_MISSION_NULL_FETCHING =
  'FORCE_ORDER_MISSION_NULL_FETCHING';
export const FORCE_ORDER_MISSION_NULL_SUCCESS =
  'FORCE_ORDER_MISSION_NULL_SUCCESS';
export const FORCE_ORDER_MISSION_NULL_FAILURE =
  'FORCE_ORDER_MISSION_NULL_FAILURE';
export const COMPLETE_MISSION_FETCHING = 'COMPLETE_MISSION_FETCHING';
export const COMPLETE_MISSION_SUCCESS = 'COMPLETE_MISSION_SUCCESS';
export const COMPLETE_MISSION_FAILURE = 'COMPLETE_MISSION_FAILURE';
export const MISSION_REMOVE_FETCHING = 'FORCE_ORDER_MISSION_NULL_FETCHING';
export const MISSION_REMOVE_SUCCESS = 'FORCE_ORDER_MISSION_NULL_SUCCESS';
export const MISSION_REMOVE_FAILURE = 'FORCE_ORDER_MISSION_NULL_FAILURE';

export const HIGHLIGHT_CRAFT = 'HIGHLIGHT_CRAFT';

export const UPDATE_TAGS_PENDING = 'UPDATE_TAGS_PENDING';
export const UPDATE_TAGS_FULFILLED = 'UPDATE_TAGS_FULFILLED';
export const UPDATE_TAGS_FAILED = 'UPDATE_TAGS_FAILED';

export const UPDATE_DEPARTURE_PAD_PENDING = 'UPDATE_DEPARTURE_PAD_PENDING';
export const UPDATE_DEPARTURE_PAD_FULFILLED = 'UPDATE_DEPARTURE_PAD_FULFILLED';
export const UPDATE_DEPARTURE_PAD_FAILED = 'UPDATE_DEPARTURE_PAD_FAILED';

export const UPDATE_SUGGESTED_DROP_PENDING = 'UPDATE_SUGGESTED_DROP_PENDING';
export const UPDATE_SUGGESTED_DROP_FULFILLED =
  'UPDATE_SUGGESTED_DROP_FULFILLED';
export const UPDATE_SUGGESTED_DROP_FAILED = 'UPDATE_SUGGESTED_DROP_FAILED';

export const UPDATE_ACCEPTED_FOR_FAILURE = 'UPDATE_ACCEPTED_FOR_FAILURE';

export const REROUTE_PENDING = 'REROUTE_PENDING';
export const REROUTE_FULFILLED = 'REROUTE_FULFILLED';
export const REROUTE_FAILURE = 'REROUTE_FAILURE';
export const SET_HOVER_ORDER = 'SET_HOVER_ORDER';
export const SET_HOVER_TEAM = 'SET_HOVER_TEAM';
export const SET_HOVER_AIRCRAFT = 'SET_HOVER_AIRCRAFT';
export const SET_HOVER_DEPARTURE_PAD = 'SET_HOVER_DEPARTURE_PAD';
export const SET_HOVER_ARRIVAL_PAD = 'SET_HOVER_ARRIVAL_PAD';
export const SET_ROUTE_CONFIRMATION_ORDER = 'SET_ROUTE_CONFIRMATION_ORDER';

export const GET_FLIGHT_TEST_PLAN_SUCCESS = 'GET_FLIGHT_TEST_PLAN_SUCCESS';
export const GET_SLOTS_FOR_LANDING_PAD = 'GET_SLOTS_FOR_LANDING_PAD';

export const FLIPDISH_MENU_SYNC_PENDING = 'FLIPDISH_MENU_SYNC_PENDING';
export const FLIPDISH_MENU_SYNC_FULFILLED = 'FLIPDISH_MENU_SYNC_FULFILLED';
export const FLIPDISH_MENU_SYNC_FAILED = 'FLIPDISH_MENU_SYNC_FAILED';

export const SET_LANE = 'SET_LANE';

export const GET_JUST_EAT_ACTIVE_PENDING = 'GET_JUST_EAT_ACTIVE_PENDING';
export const GET_JUST_EAT_ACTIVE_FULFILLED = 'GET_JUST_EAT_ACTIVE_FULFILLED';
export const GET_JUST_EAT_ACTIVE_FAILED = 'GET_JUST_EAT_ACTIVE_FAILED';

export const ACTIVATE_JUST_EAT_PENDING = 'ACTIVATE_JUST_EAT_PENDING';
export const ACTIVATE_JUST_EAT_FULFILLED = 'ACTIVATE_JUST_EAT_FULFILLED';
export const ACTIVATE_JUST_EAT_FAILED = 'ACTIVATE_JUST_EAT_FAILED';

export const DEACTIVATE_JUST_EAT_PENDING = 'ACTIVATE_JUST_EAT_PENDING';
export const DEACTIVATE_JUST_EAT_FULFILLED = 'ACTIVATE_JUST_EAT_FULFILLED';
export const DEACTIVATE_JUST_EAT_FAILED = 'ACTIVATE_JUST_EAT_FAILED';

export const GET_FLIGHT_CARDS_SUCCESS = 'GET_FLIGHT_CARDS_SUCCESS';
export const GET_DEV_ORDERS_SUCCESS = 'GET_DEV_ORDERS_SUCCESS';

export const GET_CASSETTES_SUCCESS = 'GET_CASSETTES_SUCCESS';

// Unavailable windows actions
export const GET_UNAVAILABLE_WINDOWS = 'GET_UNAVAILABLE_WINDOWS';

export const GET_MERCHANT_DEVICES_PENDING = 'GET_MERCHANT_DEVICES_PENDING';
export const GET_MERCHANT_DEVICES_FAILURE = 'GET_MERCHANT_DEVICES_FAILURE';
export const GET_MERCHANT_DEVICES_SUCCESS = 'GET_MERCHANT_DEVICES_SUCCESS';

export const CREATE_MERCHANT_DEVICES_PENDING = 'CREATE_MERCHANT_DEVICES_PENDING';
export const CREATE_MERCHANT_DEVICES_FAILURE = 'CREATE_MERCHANT_DEVICES_FAILURE';
export const CREATE_MERCHANT_DEVICES_SUCCESS = 'CREATE_MERCHANT_DEVICES_SUCCESS';

export const UPDATE_MERCHANT_DEVICES_PENDING = 'UPDATE_MERCHANT_DEVICES_PENDING';
export const UPDATE_MERCHANT_DEVICES_FAILURE = 'UPDATE_MERCHANT_DEVICES_FAILURE';
export const UPDATE_MERCHANT_DEVICES_SUCCESS = 'UPDATE_MERCHANT_DEVICES_SUCCESS';

export const DELETE_MERCHANT_DEVICES_PENDING = 'DELETE_MERCHANT_DEVICES_PENDING';
export const DELETE_MERCHANT_DEVICES_FAILURE = 'DELETE_MERCHANT_DEVICES_FAILURE';
export const DELETE_MERCHANT_DEVICES_SUCCESS = 'DELETE_MERCHANT_DEVICES_SUCCESS';

export const SET_INVALIDATING_AN_ORDERS_DROP_LOCATION = 'SET_INVALIDATING_AN_ORDERS_DROP_LOCATION';

export const UPDATE_ARRIVAL_PAD_PENDING = 'UPDATE_ARRIVAL_PAD_PENDING';
export const UPDATE_ARRIVAL_PAD_FULFILLED = 'UPDATE_ARRIVAL_PAD_FULFILLED';
export const UPDATE_ARRIVAL_PAD_FAILED = 'UPDATE_ARRIVAL_PAD_FAILED';
export const UPDATE_LANDING_ZONE_LOCALLY = 'UPDATE_LANDING_ZONE_LOCALLY';

export const SET_USE_SSE_FOR_ORDERS = 'SET_USE_SSE_FOR_ORDERS';

export const SET_SHOW_COMPLETED_CANCELLED_ORDERS = 'SET_SHOW_COMPLETED_CANCELLED_ORDERS';

export const GET_MERCHANTS_IN_CELL_REQUEST = 'GET_MERCHANTS_IN_CELL_REQUEST';
export const GET_MERCHANTS_IN_CELL_SUCCESS = 'GET_MERCHANTS_IN_CELL_SUCCESS';
export const GET_MERCHANTS_IN_CELL_FAILURE = 'GET_MERCHANTS_IN_CELL_FAILURE';

// OrderHub card upsert (SSE list maintenance)
export const ORDER_CARD_UPSERTED = 'ORDER_CARD_UPSERTED';

